var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFlipFlops(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5209 5.02876C21.0132 5.02876 18.1231 7.92024 18.1231 11.544H17.042C17.042 7.39605 20.3646 3.9873 24.5209 3.9873C28.6771 3.9873 31.9998 7.39605 31.9998 11.544H30.9187C30.9187 7.92024 28.0285 5.02876 24.5209 5.02876Z",
    fill: "#BC955C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9187 8.49342H23.9998V11.5061C26.1648 11.809 30.024 13.301 31.5371 17.487L30.5162 17.8295C29.0697 13.8278 25.1756 12.6015 23.4247 12.4934L22.9187 12.4622V8.49342Z",
    fill: "#BC955C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9998 8.49342H22.9187L22.9187 11.5357C21.3001 11.9106 18.7439 13.5048 17.7444 17.5373L18.7959 17.7792C19.8044 13.7105 22.4682 12.5859 23.5096 12.4922L23.9998 12.4481L23.9998 8.49342Z",
    fill: "#BC955C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8856 30.9586C27.6581 30.9586 29.9444 28.6927 29.9444 25.8505V25.8336L30.9194 11.393L31.9982 11.4606L31.0255 25.8678C31.0162 29.2351 28.2922 32 24.8856 32C21.4833 32 18.7619 29.2422 18.7457 25.8807L17.045 11.4856L18.1191 11.3679L19.8267 25.821V25.8505C19.8267 28.6927 22.1131 30.9586 24.8856 30.9586Z",
    fill: "#BC955C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47889 1.04146C3.97126 1.04146 1.08106 3.93294 1.08106 7.5567H0C0 3.40874 3.32262 0 7.47889 0C11.6352 0 14.9578 3.40874 14.9578 7.5567H13.8767C13.8767 3.93294 10.9865 1.04146 7.47889 1.04146Z",
    fill: "#BC955C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21605 4.53572H9.29711V7.57804C10.9157 7.95288 13.4719 9.54711 14.4714 13.5796L13.4199 13.8215C12.4114 9.75281 9.74761 8.62823 8.70629 8.5345L8.21605 8.49037V4.53572Z",
    fill: "#BC955C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29711 4.53572H8.21605V7.54836C6.05102 7.85133 2.19181 9.34325 0.6787 13.5293L1.69963 13.8718C3.14611 9.87006 7.04025 8.64376 8.79114 8.53569L9.29711 8.50446V4.53572Z",
    fill: "#BC955C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84397 26.9713C10.6164 26.9713 12.9028 24.7054 12.9028 21.8632V21.8463L13.8778 7.40568L14.9565 7.47328L13.9838 21.8805C13.9746 25.2479 11.2506 28.0127 7.84397 28.0127C4.44171 28.0127 1.72032 25.2549 1.70413 21.8934L0.00337812 7.49837L1.0775 7.38059L2.78512 21.8337V21.8632C2.78512 24.7054 5.07149 26.9713 7.84397 26.9713Z",
    fill: "#BC955C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlipFlops);
export default __webpack_public_path__ + "static/media/iconFlipFlops.5511168805b214f8433c3c59fd3b6e31.svg";
export { ForwardRef as ReactComponent };